const textData = [
    {
        id:1,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-pink-500 to-violet-500",
        twColors : ["bg-[#FFDD00]"," bg-[#FBB034]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
    {
        id:2,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#19A186] to-[#F2CF43]",
        twColors : ["bg-[#19A186]"," bg-[#F2CF43]"]
      },
      {
          id:3,
          twBg: "bg-clip-text text-transparent bg-gradient-to-r from-slate-500 to-yellow-100",
          twColors : ["bg-slate-500","bg-yellow-100"],
      },
      {
        id:4,
        twBg: "bg-clip-text text-transparent bg-gradient-to-r from-cyan-200 to-pink-200",
        twColors : ["bg-cyan-300","bg-pink-300"],
    },
    {
        id:5,
        twBg: "bg-clip-text text-transparent bg-gradient-to-r from-slate-300 to-rose-900",
        twColors : ["bg-slate-800","bg-rose-900"],
    },
    {
        id:6,
        twBg: "bg-clip-text text-transparent bg-gradient-to-r from-[#fc575e] to-[#90D5EC]",
        twColors : ["bg-[#fc575e]"," bg-[#90D5EC]"],
    },
    {
        id:7,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#29524a] to-[#e9bcb7]",
        twColors : ["bg-[#29524a]"," bg-[#e9bcb7]"],
    },
    {
        id:10,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#F5F7FA] to-[#B8C6DB]",
        twColors : ["bg-[#F5F7FA]"," bg-[#B8C6DB]"],
    },
    {
        id:11,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#647DEE] to-[#7F53AC]",
        twColors : ["bg-[#647DEE]"," bg-[#7F53AC]"],
    },
    {
        id:12,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#E5BDF6] to-[#D8DEDE]",
        twColors : ["bg-[#E5BDF6]"," bg-[#D8DEDE]"],
    },
    {
        id:13,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#09203F] to-[#537895]",
        twColors : ["bg-[#09203F]"," bg-[#537895]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:14,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500",
        twColors : ["bg-pink-500","bg-red-500","bg-yellow-500"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:15,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#D1BAD2] to-[#2884B8]",
        twColors : ["bg-[#D1BAD2]"," bg-[#2884B8]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:16,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#B3F6DB] to-[#52A7C1]",
        twColors : ["bg-[#B3F6DB]"," bg-[#52A7C1]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:17,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#F9ABA4] to-[#EFECEC]",
        twColors : ["bg-[#F9ABA4]"," bg-[#EFECEC]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:18,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#B9ABCF] to-[#2b1331]",
        twColors : ["bg-[#B9ABCF]"," bg-[#2b1331]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:19,
        twBg: "bg-clip-text text-transparent bg-gradient-to-r from-[#FFDD00] to-[#FBB034]",
        twColors : ["bg-gray-200"," bg-gray-600", " bg-gray-900"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:20,
        twBg: "bg-clip-text text-transparent bg-gradient-to-r from-[#d3d3d3] to-[#36669d]",
        twColors : ["bg-[#d3d3d3]"," bg-[#36669d]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      {
        id:21,
        twBg: " bg-clip-text text-transparent bg-gradient-to-r from-[#FFA69E] to-[#861657]",
        twColors : ["bg-[#FFA69E]"," bg-[#861657]"],
        cssColors: "background-image: linear-gradient(to right, #EC4899 , #EF4444, #F59E0B);",
      },
      
      

  ]



  export default textData